/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_ActivitiesInputs */

const en_cases_col_activities = /** @type {(inputs: Cases_Col_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activities`)
};

const pt_br2_cases_col_activities = /** @type {(inputs: Cases_Col_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades`)
};

/**
* | output |
* | --- |
* | "Activities" |
*
* @param {Cases_Col_ActivitiesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_activities = /** @type {((inputs?: Cases_Col_ActivitiesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_ActivitiesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_activities(inputs)
	return pt_br2_cases_col_activities(inputs)
});